import React from 'react';
import { Row, Col } from 'antd';
import './style.scss';
import CustomButton from '../../../../../../../../../v2-components/Antd/Button';
import CustomCheckbox from '../../../../../../../../../v2-components/Antd/Checkbox';
import CustomInputNumber from '../../../../../../../../../v2-components/Antd/InputNumber';
import Images from '../../../../../../../../../v2-components/Images';


export default function Step1ProductSelection({
  products,
  selectedProducts,
  productQuantities,
  onSelectionChange,
  onQuantityChange,
  onNext,
}) {
  const handleSelectAll = (checked) => {
    if (checked) {
      onSelectionChange(products.map(p => p.id));
    } else {
      onSelectionChange([]);
    }
  };

  console.log('Products:', products);

  const handleProductSelect = (productId, checked) => {
    if (checked) {
      onSelectionChange([...selectedProducts, productId]);
    } else {
      onSelectionChange(selectedProducts.filter(id => id !== productId));
    }
  };

  const handleQuantityChange = (productId, value) => {
    onQuantityChange(productId, value);
  };

  const isAllSelected = products.length > 0 && selectedProducts.length === products.length;
  const hasSelectedProducts = selectedProducts.length > 0;

  const formatPrice = (price) => {
    return new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      minimumFractionDigits: 0,
    }).format(price);
  };

  return (
    <div className="step-product-selection">
      <div className="step-header">
        <h2>Finalizar compra</h2>
        <p className="step-subtitle">Elige los productos para el pago</p>
      </div>

      <div className="select-all-container">
        <CustomCheckbox
          checked={isAllSelected}
          onChange={(e) => handleSelectAll(e.target.checked)}
        >
          Seleccionar todos
        </CustomCheckbox>
      </div>

      <div className="products-list">
        {products.map((product) => {
          const isSelected = selectedProducts.includes(product.id);
          const quantity = productQuantities[product.id] || product.quantity;

          return (
            <div 
              key={product.id} 
              className={`product-item ${isSelected ? 'selected' : ''}`}
            >
              <Row align="middle" gutter={16}>
                <Col style={{ flex: '0 0 40px' }}>
                  <CustomCheckbox
                    checked={isSelected}
                    onChange={(e) => handleProductSelect(product.id, e.target.checked)}
                  />
                </Col>
                
                <Col style={{ flex: '0 0 70px' }}>
                  <div className="product-image-container">
                    <Images
                      src={product.image}
                      alt={product.name}
                      classImage="product-image"
                    />
                  </div>
                </Col>

                <Col style={{ flex: '1 1 auto', minWidth: 0, overflow: 'hidden' }}>
                  <div className="product-info">
                    <span className="product-name">{product.name}</span>
                    <span className="product-laboratory">
                      Laboratorio: {product.laboratory}
                    </span>
                    <span className="product-sku">
                      SKU: {product.sku}
                    </span>
                  </div>
                </Col>

                <Col style={{ flex: '0 0 120px' }}>
                  <div className="product-price">
                    <span className="price-label">Precio unitario</span>
                    <span className="price-value">{formatPrice(product.quotation_price?.final_unit_price)}</span>
                  </div>
                </Col>

                <Col style={{ flex: '0 0 100px' }}>
                  <div className="product-quantity">
                    <span className="quantity-label">Cantidad</span>
                    <CustomInputNumber
                      min={1}
                      max={product.quantity}
                      value={quantity}
                      onChange={(value) => handleQuantityChange(product.id, value)}
                      disabled={!isSelected}
                    />
                  </div>
                </Col>
              </Row>
            </div>
          );
        })}

        {products.length === 0 && (
          <div className="no-products">
            <p>No hay productos disponibles en esta cotización.</p>
          </div>
        )}
      </div>

      <div className="step-footer">
        <CustomButton
          type="primary"
          onClick={onNext}
          disabled={!hasSelectedProducts}
          className="btn-continue"
        >
          Continuar
        </CustomButton>
      </div>
    </div>
  );
}
